import React, { useCallback } from 'react'

import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { Button, IconButton } from '@mui/material'

import { linkButtonStyle } from '../styles/components/LinkButton'

const LinkButton = ({ handleClick = null, url, icon, text = '', ...props }) => {
  const navigate = useNavigate()
  const handleRedirect = useCallback(() => navigate(url), [navigate, url])

  const handleActions = () => {
    handleClick && handleClick()
    handleRedirect()
  }

  return (
    <>
      {text ? (
        <Button onClick={handleActions} sx={linkButtonStyle} {...props}>
          {icon && icon}
          <span>{text}</span>
        </Button>
      ) : (
        <IconButton onClick={handleActions} sx={linkButtonStyle} {...props}>
          {icon}
        </IconButton>
      )}
    </>
  )
}

LinkButton.propTypes = {
  handleClick: PropTypes.func,
  url: PropTypes.string,
  icon: PropTypes.element,
  text: PropTypes.string,
}

export default LinkButton
